import { PathsTaggeoEnum } from "../enums/paths-taggeo.enum";
import { TitleOptionEnum } from "../enums/title-option.enum";
import { SetEventInterface } from "../interfaces/tagging.interface";

export const cancelAccounts: SetEventInterface = {
  event: "payments",
  categoria: "recarga_celular",
  accion: "seleccion_cuenta",
  etiqueta: "cancelar",
  canalBanco: "supermovil",
  url: "recarga_celular/seleccion_cuenta",
  userID: "",
};

export const cancelAmounts: SetEventInterface = {
  event: "payments",
  categoria: "recarga_celular",
  accion: "seleccion_monto",
  etiqueta: "cerrar",
  canalBanco: "supermovil",
  url: "recarga_celular/seleccion_monto",
  userID: "",
};

export const cancelConfirmation: SetEventInterface = {
  event: "payments",
  categoria: "recarga_celular",
  accion: "confirmacion",
  etiqueta: "cancelar",
  canalBanco: "supermovil",
  url: "recarga_celular/confirmacion",
  userID: "",
};

export const cancelOff: SetEventInterface = {
  event: "payments",
  categoria: "recarga_celular",
  accion: "popup_no_te_quedes_sin_saldo",
  etiqueta: "cancelar",
  canalBanco: "supermovil",
  url: "recarga_celular/popup/no_te_quedes_sin_saldo",
  userID: "",
}

export const cancelScheduled: SetEventInterface = {
  event: "payments",
  categoria: "recarga_celular",
  accion: "pago_automatico",
  etiqueta: "cancelar",
  canalBanco: "supermovil",
  url: "recarga_celular/pago_automatico",
  userID: "",
}

export const cancelConfirmScheduled: SetEventInterface = {
  event: "payments",
  categoria: "pago_automatico",
  accion: "confirmacion",
  etiqueta: "cancelar",
  canalBanco: "supermovil",
  url: "pago_automatico/recarga_celular/confirmacion",
  userID: "",
}

export const history: string = "recarga_celular/";
export const captura: string = "recarga_celular/confirmacion";
export const companies: string = "recarga_celular/selecciona_compania";
export const ticket: string = "recarga_celular/comprobante";

export const flowsOption = new Map<TitleOptionEnum, SetEventInterface>();

flowsOption.set(TitleOptionEnum.origin, cancelAccounts);
flowsOption.set(TitleOptionEnum.originFrom, cancelAccounts);
flowsOption.set(TitleOptionEnum.amount, cancelAmounts);
flowsOption.set(TitleOptionEnum.confirm, cancelConfirmation);
flowsOption.set(TitleOptionEnum.off, cancelOff);
flowsOption.set(TitleOptionEnum.schedule, cancelScheduled);
flowsOption.set(TitleOptionEnum.scheduleConfirm, cancelConfirmScheduled);

export const pathsTaggeo = new Map<PathsTaggeoEnum, string>();
pathsTaggeo.set(PathsTaggeoEnum.history, history);
pathsTaggeo.set(PathsTaggeoEnum.captura, captura);
pathsTaggeo.set(PathsTaggeoEnum.companies, companies);
pathsTaggeo.set(PathsTaggeoEnum.ticket, ticket);
